import PropTypes from 'prop-types';
import React, { createContext, useContext, useReducer } from 'react';

import AgendamentoAlteracaoActionTypes from '../Reducers/AgendamentoAlteracao/actions';
import {
  AGENDAMENTO_INICIAL,
  AgendamentoAlteracaoReducer,
} from '../Reducers/AgendamentoAlteracao/reducer';

export const AgendamentoAlteracaoContext = createContext();

export function useAgendamentoAlteracaoContext() {
  const context = useContext(AgendamentoAlteracaoContext);
  return context;
}

export default function AgendamentoAlteracaoProvider({ children }) {
  const [agendamentosAlteracao, dispatch] = useReducer(
    AgendamentoAlteracaoReducer,
    AGENDAMENTO_INICIAL
  );

  const setAgendamentosAlteracao = agendamentos => {
    dispatch({
      type: AgendamentoAlteracaoActionTypes.SET_AGENDAMENTOS,
      payload: agendamentos,
    });
  };

  const removeAgendamentoAlteracao = agendamento => {
    dispatch({
      type: AgendamentoAlteracaoActionTypes.REMOVE_AGENDAMENTO,
      payload: agendamento,
    });
  };

  return (
    <AgendamentoAlteracaoContext.Provider
      value={{
        agendamentosAlteracao,
        setAgendamentosAlteracao,
        removeAgendamentoAlteracao,
        dispatch,
      }}
    >
      {children}
    </AgendamentoAlteracaoContext.Provider>
  );
}

AgendamentoAlteracaoProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

AgendamentoAlteracaoContext.displayName = 'AgendamentoAlteracaoContext';
